import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SoilSpecieService } from '../proxy/planning/controllers/soil-specie.service';
import { UnitOfMeasureService } from '@general/proxy/general/controllers/unit-of-measure.service';

FieldBuilder.setNamespace('Planning');

export const SOILMEASUREMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilMeasurementType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SoilMeasurementType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('soilSpecieId', 'Entity.SoilSpecie', SoilSpecieService)
    .required()
    .displayFromNested('soilSpecie.name')
    .sortBy('soilSpecie.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('unitOfMeasureId', 'Entity.UnitOfMeasure', UnitOfMeasureService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const SOILMEASUREMENTTYPE_CONFIG = {
  entityName: 'SoilMeasurementType',
  localizationKey: 'Planning::Entity.SoilMeasurementType',
  fields: SOILMEASUREMENTTYPE_FIELDS,
  permission: 'PlanningEnvironment.SoilMeasurementTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
